import { createApp } from 'vue'
const components = import.meta.glob('../components/vue.js/*.vue', { eager: true })
import '@/styles/bulma_namespaced.css'

// create component in frontend/components/vue.js/Component.vue
// then, use in views like this:
// div data-vue-component="Component"

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vue-component]').forEach((el) => {
    const name = el.dataset.vueComponent

    import(`../components/vue.js/${name}.vue`)
      .then((module) => {
        const Component = module.default
        createApp(Component).mount(el)
      })
      .catch((err) => {
        console.error(`Failed to load Vue component: ${name}`, err)
      })
  })
})
